module.exports = __webpack_public_path__ + "static/media/premio-ana-2020.8280ef7b.webp";